(() => {
  const activeCurrency = () => document.documentElement.dataset.currency || window.Shopify?.currency?.active || 'USD';
  const activeLocale = () => document.documentElement.lang || window.Shopify?.locale || 'en-US';
  const variantLabels = {
    de: { 'Cloud White': 'Wolkenweiß', Graphite: 'Graphit', Right: 'Rechts', Left: 'Links' },
    pl: { 'Cloud White': 'Biel', Graphite: 'Grafit', Right: 'Prawe', Left: 'Lewe' },
    fr: { 'Cloud White': 'Blanc nuage', Graphite: 'Graphite', Right: 'Droit', Left: 'Gauche' },
    nl: { 'Cloud White': 'Wolkwit', Graphite: 'Grafiet', Right: 'Rechts', Left: 'Links' }
  };
  const localizeVariantTitle = value => {
    const locale = activeLocale().split('-')[0].toLowerCase();
    const labels = variantLabels[locale];
    if (!labels) return value;
    return String(value || '').split(' / ').map(part => labels[part] || part).join(' / ');
  };
  const cartErrorMessages = {
    en: 'We could not update your cart. Your existing cart was kept. Please try again.',
    de: 'Der Warenkorb konnte nicht aktualisiert werden. Dein bisheriger Warenkorb wurde beibehalten. Bitte versuche es erneut.',
    pl: 'Nie udało się zaktualizować koszyka. Dotychczasowa zawartość została zachowana. Spróbuj ponownie.',
    fr: 'Le panier n’a pas pu être mis à jour. Son contenu actuel a été conservé. Veuillez réessayer.',
    nl: 'Je winkelwagen kon niet worden bijgewerkt. De bestaande inhoud is bewaard. Probeer het opnieuw.'
  };
  const cartErrorMessage = () => {
    const locale = activeLocale().split('-')[0].toLowerCase();
    return cartErrorMessages[locale] || cartErrorMessages.en;
  };
  const money = cents => new Intl.NumberFormat(activeLocale(), {
    style: 'currency',
    currency: activeCurrency()
  }).format(Number(cents || 0) / 100);

  const localizationKey = 'kynora-localization-v1';
  const localizationSessionKey = 'kynora-localization-attempt-v2';
  const supportedLanguages = new Set(['en', 'de', 'pl', 'fr', 'nl']);
  const countryDefaultLanguage = { PL: 'pl', DE: 'de', FR: 'fr', NL: 'nl' };
  const currentCountryCode = () => String(window.Shopify?.country || '').toUpperCase();
  const currentLanguageCode = () => String(
    window.Shopify?.language || window.Shopify?.locale || document.documentElement.lang || 'en'
  ).split('-')[0].toLowerCase();
  const saveLocalizationPreference = value => {
    try {
      localStorage.setItem(localizationKey, JSON.stringify(value));
    } catch (_) {}
  };
  const saveManualLocalization = overrides => saveLocalizationPreference({
    mode: 'manual',
    country: currentCountryCode(),
    language: currentLanguageCode(),
    savedAt: Date.now(),
    ...overrides
  });

  document.querySelectorAll('[data-localization-select]').forEach(select => {
    const form = select.closest('form');
    form?.addEventListener('submit', () => saveManualLocalization({ country: select.value }));
    select.addEventListener('change', () => {
      saveManualLocalization({ country: select.value });
      form?.submit();
    });
  });
  document.querySelectorAll('button[name="language_code"]').forEach(button => {
    button.addEventListener('click', () => {
      const country = String(button.dataset.countryCode || currentCountryCode()).toUpperCase();
      const countryInput = button.closest('form')?.querySelector('[data-header-country-code]');
      if (countryInput) countryInput.value = country;
      saveManualLocalization({ language: button.value, country });
    });
  });

  const discoverLocalization = async () => {
    const currentCountry = currentCountryCode();
    const currentLanguage = currentLanguageCode();
    if (!currentCountry) return;
    try {
      if (sessionStorage.getItem(localizationSessionKey)) return;
      sessionStorage.setItem(localizationSessionKey, '1');
      const stored = JSON.parse(localStorage.getItem(localizationKey) || 'null');
      if (stored?.mode === 'manual') return;
      if (
        stored?.country === currentCountry &&
        stored?.language === currentLanguage &&
        Date.now() - Number(stored.savedAt || 0) < 2592000000
      ) return;
    } catch (_) {}

    try {
      const root = window.Shopify?.routes?.root || '/';
      const query = new URLSearchParams({
        'country[enabled]': 'true',
        'country[exclude]': currentCountry,
        'language[enabled]': 'true',
        'language[exclude]': currentLanguage
      });
      const response = await fetch(`${root}browsing_context_suggestions.json?${query.toString()}`, {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const data = await response.json();
      const suggestions = data.suggestions || [];
      const countrySuggestion = suggestions.find(item => item.parts?.country?.handle);
      const languageSuggestion = suggestions.find(item => item.parts?.language?.handle);
      const suggestedCountry = String(
        countrySuggestion?.parts?.country?.handle || currentCountry
      ).toUpperCase();
      const suggestedBrowserLanguage = String(
        languageSuggestion?.parts?.language?.handle || ''
      ).split('-')[0].toLowerCase();
      const suggestedLanguage = supportedLanguages.has(suggestedBrowserLanguage)
        ? suggestedBrowserLanguage
        : (countryDefaultLanguage[suggestedCountry] || currentLanguage);
      const finalLanguage = supportedLanguages.has(suggestedLanguage) ? suggestedLanguage : 'en';

      saveLocalizationPreference({
        mode: 'auto',
        country: suggestedCountry,
        language: finalLanguage,
        savedAt: Date.now()
      });
      if (suggestedCountry === currentCountry && finalLanguage === currentLanguage) return;

      const form = document.createElement('form');
      form.action = '/localization';
      form.method = 'POST';
      form.hidden = true;
      const addField = (name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.append(input);
      };
      addField('_method', 'PUT');
      addField('country_code', suggestedCountry);
      addField('language_code', finalLanguage);
      addField('return_to', location.pathname + location.search);
      document.body.append(form);
      form.submit();
    } catch (_) {}
  };
  discoverLocalization();

  document.querySelectorAll('[data-kynora-product]').forEach(root => {
    const cards = [...root.querySelectorAll('[data-bundle-card]')];
    let selected = root.querySelector('[data-bundle-card].selected') || cards[0];
    let variants = [];
    const json = root.querySelector('[data-product-json]');
    if (json) {
      try { variants = JSON.parse(json.textContent); } catch (_) {}
    }
    let productConfig = {};
    const productConfigNode = root.querySelector('[data-product-config]');
    if (productConfigNode) {
      try { productConfig = JSON.parse(productConfigNode.textContent); } catch (_) {}
    }
    const localizedEach = amount => String(productConfig.offerEach || `${amount} each`).replace('__AMOUNT__', amount);
    const update = () => {
      if (!selected) return;
      cards.forEach(card => {
        const active = card === selected;
        card.classList.toggle('selected', active);
        card.querySelector('.bundle-head')?.setAttribute('aria-expanded', active);
      });
      const price = Number(selected.dataset.priceCents);
      const compare = Number(selected.dataset.compareCents);
      const title = selected.dataset.title;
      const priceNode = root.querySelector('[data-bundle-price]');
      const compareNode = root.querySelector('[data-bundle-compare]');
      const saveNode = root.querySelector('[data-bundle-save]');
      const titleNode = root.querySelector('[data-bundle-title]');
      if (priceNode) priceNode.textContent = money(price);
      if (compareNode) compareNode.textContent = money(compare);
      if (saveNode) saveNode.textContent = `${productConfig.save || 'SAVE'} ${money(compare - price)}`;
      if (titleNode) titleNode.textContent = title;
      const mobilePrice = document.querySelector('[data-mobile-price]');
      const mobileBundle = document.querySelector('[data-mobile-bundle]');
      if (mobilePrice) mobilePrice.textContent = money(price);
      if (mobileBundle) mobileBundle.textContent = title;
    };
    cards.forEach(card => {
      const price = Number(card.dataset.priceCents);
      const compare = Number(card.dataset.compareCents);
      const count = Math.max(1, Number(card.dataset.count) || 1);
      const priceNode = card.querySelector('[data-offer-price]');
      const eachNode = card.querySelector('[data-offer-each]');
      const compareNode = card.querySelector('[data-offer-compare]');
      if (priceNode) priceNode.textContent = money(price);
      if (eachNode) eachNode.textContent = localizedEach(money(Math.round(price / count)));
      if (compareNode) compareNode.textContent = money(compare);
    });
    const firstCard = cards[0];
    if (firstCard) {
      document.querySelectorAll('[data-last-call-price]').forEach(node => {
        node.textContent = money(Number(firstCard.dataset.priceCents));
      });
      document.querySelectorAll('[data-last-call-compare]').forEach(node => {
        node.textContent = money(Number(firstCard.dataset.compareCents));
      });
    }
    cards.forEach(card => card.querySelector('.bundle-head').addEventListener('click', () => {
      selected = card;
      update();
    }));
    const galleryButtons = [...root.querySelectorAll('[data-gallery-src]')];
    const galleryMain = root.querySelector('.js-main-product-image');
    let galleryIndex = Math.max(0, galleryButtons.findIndex(button => button.classList.contains('active')));
    const setGallery = index => {
      if (!galleryButtons.length || !galleryMain) return;
      galleryIndex = (index + galleryButtons.length) % galleryButtons.length;
      const button = galleryButtons[galleryIndex];
      galleryMain.removeAttribute('srcset');
      galleryMain.removeAttribute('sizes');
      galleryMain.src = button.dataset.gallerySrc;
      if (button.dataset.galleryAlt) galleryMain.alt = button.dataset.galleryAlt;
      galleryButtons.forEach((item, itemIndex) => {
        const active = itemIndex === galleryIndex;
        item.classList.toggle('active', active);
        item.setAttribute('aria-current', active ? 'true' : 'false');
      });
      button.parentElement?.scrollTo({
        left: Math.max(0, button.offsetLeft - button.parentElement.clientWidth / 2 + button.clientWidth / 2),
        behavior: 'smooth'
      });
    };
    galleryButtons.forEach((button, index) => button.addEventListener('click', () => setGallery(index)));
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => setGallery(galleryIndex - 1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => setGallery(galleryIndex + 1));
    const normalizeOption = value => String(value ?? '').trim().toLocaleLowerCase('en-US');
    const findVariant = row => {
      if (!variants.length) return null;
      const chosen = [...row.querySelectorAll('select')].map(select => normalizeOption(select.value));
      return variants.find(variant => (
        variant.available !== false
        && variant.options.length === chosen.length
        && variant.options.every((option, index) => normalizeOption(option) === chosen[index])
      )) || null;
    };
    const add = async checkout => {
      if (!variants.length) {
        alert('Select a Shopify product in Customize, then add Color, Knee and Size variants.');
        return;
      }
      const grouped = new Map();
      [...selected.querySelectorAll('.unit-row')].forEach(row => {
        const variant = findVariant(row);
        if (!variant) return;
        const existing = grouped.get(String(variant.id));
        if (existing) {
          existing.quantity += 1;
        } else {
          const bundleCount = Math.max(1, Number(selected.dataset.count) || 1);
          const compareUnit = Math.round(Number(selected.dataset.compareCents || 0) / bundleCount);
          grouped.set(String(variant.id), {
            id: variant.id,
            quantity: 1,
            properties: {
              _bundle: selected.dataset.title,
              _compare_unit: String(compareUnit)
            }
          });
        }
      });
      const items = [...grouped.values()];
      const protectionUpsell = root.querySelector('[data-protection-upsell]');
      const protectionToggle = root.querySelector('[data-protection-toggle]');
      if (protectionToggle?.checked && protectionUpsell?.dataset.protectionVariantId) {
        items.push({
          id: Number(protectionUpsell.dataset.protectionVariantId),
          quantity: 1,
          properties: { _protection: '90-day' }
        });
      }
      if (!items.length) {
        alert('No available matching variants were found.');
        return;
      }
      const button = root.querySelector('[data-add-bundle]');
      const originalButton = button.innerHTML;
      button.disabled = true;
      button.textContent = 'ADDING…';
      try {
        if (window.KynoraCart?.replaceBundle) {
          await window.KynoraCart.replaceBundle(items);
        } else {
          const storefrontRoot = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${storefrontRoot}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error();
        }
        if (checkout) {
          window.location.href = `${window.Shopify?.routes?.root || '/'}checkout`;
          return;
        }
        await window.KynoraCart?.open(button);
      } catch (error) {
        console.error('Kynora bundle add failed:', error);
        alert(cartErrorMessage());
      } finally {
        button.disabled = false;
        button.innerHTML = originalButton;
        update();
      }
    };
    root.querySelector('[data-add-bundle]').addEventListener('click', () => add(false));
    root.querySelector('[data-buy-now]').addEventListener('click', () => add(true));
    document.querySelector('[data-mobile-add]')?.addEventListener('click', () => add(false));
    update();
  });

  document.querySelectorAll('[data-accordion-button]').forEach(button => button.addEventListener('click', () => {
    const item = button.parentElement;
    item.classList.toggle('is-open');
    const icon = button.querySelector('i, b:last-child');
    if (icon) icon.textContent = item.classList.contains('is-open') ? '−' : '+';
  }));

  document.querySelectorAll('[data-mobile-gallery]').forEach(gallery => {
    const galleryRoot = gallery.closest('.gallery-wrap');
    const counter = galleryRoot?.querySelector('[data-gallery-counter]');
    const slides = [...gallery.querySelectorAll('figure')];
    if (!counter || slides.length < 2) return;
    let active = 0;
    const updateCounter = () => {
      const center = gallery.scrollLeft + gallery.clientWidth / 2;
      active = 0;
      slides.forEach((slide, index) => {
        const currentDistance = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center);
        const activeDistance = Math.abs(slides[active].offsetLeft + slides[active].offsetWidth / 2 - center);
        if (currentDistance < activeDistance) active = index;
      });
      counter.textContent = `${active + 1} / ${slides.length}`;
    };
    const goTo = index => {
      active = Math.min(slides.length - 1, Math.max(0, index));
      gallery.scrollTo({
        left: slides[active].offsetLeft - gallery.offsetLeft,
        behavior: 'smooth'
      });
    };
    galleryRoot.querySelector('[data-mobile-gallery-prev]')?.addEventListener('click', () => goTo(active - 1));
    galleryRoot.querySelector('[data-mobile-gallery-next]')?.addEventListener('click', () => goTo(active + 1));
    gallery.addEventListener('scroll', updateCounter, { passive: true });
    updateCounter();
  });

  document.querySelectorAll('[data-lifestyle-carousel]').forEach(carousel => {
    const track = carousel.querySelector('[data-lifestyle-track]');
    const slides = [...carousel.querySelectorAll('[data-lifestyle-slide]')];
    const dots = [...carousel.querySelectorAll('[data-lifestyle-dot]')];
    if (!track || slides.length < 2 || dots.length !== slides.length) return;
    let activeIndex = 0;
    let scrollFrame = 0;
    const setActive = index => {
      activeIndex = Math.min(slides.length - 1, Math.max(0, index));
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false'));
    };
    const updateFromScroll = () => {
      const center = track.scrollLeft + track.clientWidth / 2;
      let nearestIndex = 0;
      slides.forEach((slide, index) => {
        const nearestDistance = Math.abs(slides[nearestIndex].offsetLeft + slides[nearestIndex].offsetWidth / 2 - center);
        const slideDistance = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center);
        if (slideDistance < nearestDistance) nearestIndex = index;
      });
      setActive(nearestIndex);
    };
    dots.forEach((dot, index) => dot.addEventListener('click', () => {
      setActive(index);
      track.scrollTo({
        left: Math.max(0, slides[index].offsetLeft - (track.clientWidth - slides[index].offsetWidth) / 2),
        behavior: 'smooth'
      });
    }));
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(updateFromScroll);
    }, { passive: true });
    setActive(0);
  });

  document.querySelectorAll('[data-before-after]').forEach(comparison => {
    const range = comparison.querySelector('[data-before-after-range]');
    if (!range) return;
    const updateComparison = () => {
      const position = `${range.value}%`;
      comparison.style.setProperty('--before-after-position', position);
      range.setAttribute('aria-valuetext', `${range.value}% before, ${100 - Number(range.value)}% after`);
    };
    range.addEventListener('input', updateComparison);
    updateComparison();
  });

  const siteMenu = document.querySelector('[data-site-menu-drawer]');
  if (siteMenu) {
    const menuPanel = siteMenu.querySelector('.site-menu-drawer__panel');
    const menuTrigger = document.querySelector('[data-site-menu-open]');
    let menuLastTrigger = null;
    const openMenu = trigger => {
      menuLastTrigger = trigger || document.activeElement;
      siteMenu.classList.add('is-open');
      siteMenu.setAttribute('aria-hidden', 'false');
      menuTrigger?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('site-menu-open');
      menuPanel?.focus();
    };
    const closeMenu = () => {
      siteMenu.classList.remove('is-open');
      siteMenu.setAttribute('aria-hidden', 'true');
      menuTrigger?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('site-menu-open');
      menuLastTrigger?.focus?.();
    };
    menuTrigger?.addEventListener('click', () => openMenu(menuTrigger));
    siteMenu.querySelectorAll('[data-site-menu-close]').forEach(button => button.addEventListener('click', closeMenu));
    siteMenu.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && siteMenu.classList.contains('is-open')) closeMenu();
    });
  }

  const sizeGuide = document.querySelector('[data-size-guide-modal]');
  if (sizeGuide) {
    let sizeGuideTrigger = null;
    const openSizeGuide = trigger => {
      sizeGuideTrigger = trigger;
      if (typeof sizeGuide.showModal === 'function') sizeGuide.showModal();
      else sizeGuide.setAttribute('open', '');
      document.body.classList.add('size-guide-open');
    };
    const closeSizeGuide = () => {
      if (typeof sizeGuide.close === 'function') sizeGuide.close();
      else sizeGuide.removeAttribute('open');
      document.body.classList.remove('size-guide-open');
      sizeGuideTrigger?.focus?.();
    };
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-size-guide-open]');
      if (trigger) {
        event.preventDefault();
        openSizeGuide(trigger);
      }
    });
    sizeGuide.querySelectorAll('[data-size-guide-close]').forEach(button => button.addEventListener('click', closeSizeGuide));
    sizeGuide.addEventListener('click', event => {
      if (event.target === sizeGuide) closeSizeGuide();
    });
    sizeGuide.addEventListener('cancel', event => {
      event.preventDefault();
      closeSizeGuide();
    });
    sizeGuide.addEventListener('close', () => document.body.classList.remove('size-guide-open'));
  }

  const drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) {
    const panel = drawer.querySelector('.cart-drawer__panel');
    const itemsRoot = drawer.querySelector('[data-cart-items]');
    const footer = drawer.querySelector('[data-cart-footer]');
    const subtotal = drawer.querySelector('[data-cart-subtotal]');
    const savings = drawer.querySelector('[data-cart-savings]');
    const checkoutLink = drawer.querySelector('[data-cart-checkout]');
    const progress = drawer.querySelector('[data-cart-progress]');
    const progressCopy = drawer.querySelector('[data-cart-progress-copy]');
    const progressFill = drawer.querySelector('[data-cart-progress-fill]');
    const progressSteps = [...drawer.querySelectorAll('[data-cart-progress-step]')];
    const configNode = document.querySelector('[data-cart-config]');
    const storefrontRoot = window.Shopify?.routes?.root || '/';
    const cartRoute = path => `${storefrontRoot}${String(path).replace(/^\/+/, '')}`;
    let config = {};
    let cartVariants = [];
    let lastTrigger = null;
    let quantityUpdatePending = false;
    try { config = JSON.parse(configNode?.textContent || '{}'); } catch (_) {}
    try {
      cartVariants = JSON.parse(document.querySelector('[data-product-json]')?.textContent || '[]');
    } catch (_) {}
    const tiers = {
      1: { code: '' },
      2: { code: 'KYNORA2' },
      3: { code: 'KYNORA3' }
    };
    const escapeHtml = value => String(value ?? '').replace(/[&<>'"]/g, character => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;'
    })[character]);
    const formatMoney = (cents, currency = activeCurrency()) => new Intl.NumberFormat(activeLocale(), {
      style: 'currency',
      currency
    }).format(Number(cents || 0) / 100);
    const tierFor = quantity => {
      const count = Math.max(1, Number(quantity) || 1);
      if (count <= 3) return tiers[count];
      return { code: 'KYNORA4PLUS' };
    };
    const updateCounts = count => document.querySelectorAll('[data-header-cart-count]').forEach(node => {
      node.textContent = count;
    });
    const isProtection = item => item?.handle === '90-day-extra-protection' || item?.properties?._protection === '90-day';
    const supportItemsFrom = cart => cart.items.filter(item => !isProtection(item));
    const protectionItemsFrom = cart => cart.items.filter(isProtection);
    const itemQuantity = items => items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    const normalizeCartOption = value => String(value ?? '').trim().toLocaleLowerCase('en-US');
    const variantForOptions = options => cartVariants.find(variant => (
      variant.available !== false
      && variant.options.length === options.length
      && variant.options.every((option, index) => normalizeCartOption(option) === normalizeCartOption(options[index]))
    )) || null;
    const variantForId = id => cartVariants.find(variant => String(variant.id) === String(id)) || null;
    const valuesForOption = index => [...new Set(
      cartVariants
        .filter(variant => variant.available !== false)
        .map(variant => variant.options[index])
        .filter(Boolean)
    )];
    const renderCartSelect = (values, selectedValue, optionIndex, label) => {
      const options = values.map(value => (
        `<option value="${escapeHtml(value)}" ${normalizeCartOption(value) === normalizeCartOption(selectedValue) ? 'selected' : ''}>${escapeHtml(localizeVariantTitle(value))}</option>`
      )).join('');
      return `<label><span>${escapeHtml(label)}</span><select data-cart-unit-option="${optionIndex}">${options}</select></label>`;
    };
    const renderUnitEditors = supportItems => {
      if (!cartVariants.length) return '';
      const colorValues = valuesForOption(0);
      const kneeValues = valuesForOption(1);
      const sizeValues = valuesForOption(2);
      let itemIndex = 0;
      const editors = [];
      supportItems.forEach(item => {
        const variant = variantForId(item.variant_id);
        const selectedOptions = variant?.options || String(item.variant_title || '').split(' / ');
        if (selectedOptions.length !== 3) return;
        for (let unitOffset = 0; unitOffset < Number(item.quantity || 0); unitOffset += 1) {
          itemIndex += 1;
          editors.push(`<div class="cart-unit-editor" data-cart-unit-editor data-line-key="${escapeHtml(item.key)}"><b class="cart-unit-editor__number">${escapeHtml(config.item || 'ITEM')} ${itemIndex}</b><div class="cart-unit-editor__fields">${renderCartSelect(colorValues, selectedOptions[0], 0, config.color || 'COLOR')}${renderCartSelect(kneeValues, selectedOptions[1], 1, config.knee || 'KNEE')}${renderCartSelect(sizeValues, selectedOptions[2], 2, config.size || 'SIZE')}</div><button type="button" data-cart-unit-apply disabled>${escapeHtml(config.update || 'UPDATE')}</button></div>`);
        }
      });
      if (!editors.length) return '';
      return `<section class="cart-bundle__customizer"><header><b>${escapeHtml(config.customizeTitle || 'CUSTOMIZE YOUR SUPPORTS')}</b><span>${escapeHtml(config.customizeCopy || 'Each item can be different')}</span></header><div>${editors.join('')}</div></section>`;
    };
    const compareLineTotal = item => {
      const compareUnit = Number(item?.properties?._compare_unit || 0);
      return compareUnit > 0
        ? compareUnit * Number(item.quantity || 0)
        : Number(item.original_line_price || item.final_line_price || item.line_price || 0);
    };
    const updateProgress = quantity => {
      if (!progress) return;
      progress.hidden = quantity < 1;
      if (quantity < 1) return;
      const stage = Math.min(3, Math.max(1, quantity));
      if (progressCopy) {
        progressCopy.textContent = stage === 1
          ? (config.progressOne || 'Add 1 more to unlock FREE SHIPPING')
          : stage === 2
            ? (config.progressTwo || 'FREE SHIPPING unlocked — add 1 more for BEST VALUE')
            : (config.progressThree || 'BEST VALUE unlocked');
      }
      if (progressFill) progressFill.style.width = stage === 1 ? '0%' : stage === 2 ? '50%' : '100%';
      progressSteps.forEach(step => {
        const stepNumber = Number(step.dataset.cartProgressStep || 0);
        step.classList.toggle('is-active', stepNumber <= stage);
      });
    };
    const render = cart => {
      updateCounts(cart.item_count);
      const countNode = drawer.querySelector('[data-cart-count]');
      if (countNode) countNode.textContent = `(${cart.item_count})`;
      footer.hidden = cart.item_count === 0;
      if (!cart.item_count) {
        updateProgress(0);
        itemsRoot.innerHTML = `<div class="cart-drawer__empty"><strong>${escapeHtml(config.emptyTitle || 'Your cart is empty')}</strong><span>${escapeHtml(config.emptyCopy || 'Choose your Kynora bundle to get moving.')}</span></div>`;
        return;
      }

      const supportItems = supportItemsFrom(cart);
      const protectionItems = protectionItemsFrom(cart);
      const supportQuantity = itemQuantity(supportItems);
      const tier = tierFor(Math.max(1, supportQuantity));
      const currency = cart.currency || activeCurrency();
      const supportCompareTotal = supportItems.reduce((sum, item) => sum + compareLineTotal(item), 0);
      const protectionFinalTotal = protectionItems.reduce((sum, item) => sum + Number(item.final_line_price || item.line_price || 0), 0);
      const finalTotal = Number(cart.total_price ?? cart.items.reduce((sum, item) => sum + Number(item.final_line_price || item.line_price || 0), 0));
      const comparisonTotal = supportCompareTotal + protectionFinalTotal;
      const discountTotal = Math.max(0, comparisonTotal - finalTotal);

      updateProgress(supportQuantity);

      const cards = [];
      if (supportItems.length) {
        const first = supportItems[0];
        const supportFinal = supportItems.reduce((sum, item) => sum + Number(item.final_line_price || item.line_price || 0), 0);
        const supportDiscount = Math.max(0, supportCompareTotal - supportFinal);
        const variantTitles = [...new Set(supportItems.map(item => localizeVariantTitle(item.variant_title)).filter(Boolean))];
        const variantSummary = variantTitles.length === 1
          ? variantTitles[0]
          : `${variantTitles.length} ${config.selectedFits || 'selected fits'}`;
        const fitChips = variantTitles.slice(0, 3).map(title => `<span>${escapeHtml(title)}</span>`).join('');
        const image = first.image
          ? `<img class="cart-bundle__image" src="${escapeHtml(first.image)}&width=360" alt="${escapeHtml(first.product_title)}">`
          : '<div class="cart-bundle__image"></div>';
        const decrease = Math.max(1, supportQuantity - 1);
        const increase = supportQuantity + 1;
        const unitEditors = renderUnitEditors(supportItems);
        cards.push(`<article class="cart-bundle">${image}<div class="cart-bundle__content"><span class="cart-bundle__label">KYNORA DIALFIT™</span><a class="cart-bundle__title" href="${escapeHtml(first.url)}">${escapeHtml(first.product_title)}</a><p class="cart-bundle__variant">${escapeHtml(variantSummary)}</p>${fitChips ? `<div class="cart-bundle__fits">${fitChips}</div>` : ''}<div class="cart-bundle__bottom"><div class="cart-bundle__controls" aria-label="${escapeHtml(config.chooseQuantity || 'Choose your quantity')}"><button type="button" data-bundle-quantity="${decrease}" ${supportQuantity === 1 ? 'disabled' : ''} aria-label="${escapeHtml(config.decrease || 'Decrease quantity')}">−</button><b>${supportQuantity}</b><button type="button" data-bundle-quantity="${increase}" aria-label="${escapeHtml(config.increase || 'Increase quantity')}">+</button></div><div class="cart-bundle__prices"><del>${formatMoney(supportCompareTotal, currency)}</del><strong>${formatMoney(supportFinal, currency)}</strong></div></div>${supportDiscount > 0 ? `<span class="cart-bundle__saving">${escapeHtml(config.save || 'SAVE')} ${formatMoney(supportDiscount, currency)}</span>` : ''}</div><button class="cart-bundle__remove" type="button" data-cart-remove aria-label="${escapeHtml(config.remove || 'Remove')}"><svg aria-hidden="true" viewBox="0 0 24 24"><path d="M8 8v10m4-10v10m4-10v10M5 5h14m-11 0 1-2h6l1 2m1 0-1 16H8L7 5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7"/></svg></button>${unitEditors}</article>`);
      }
      protectionItems.forEach(item => {
        const linePrice = Number(item.final_line_price || item.line_price || 0);
        cards.push(`<article class="cart-protection-line"><span class="cart-protection-line__icon" aria-hidden="true">✓</span><div><b>${escapeHtml(item.product_title)}</b><small>${escapeHtml(item.variant_title === 'Default Title' ? '' : item.variant_title)}</small><button type="button" data-cart-remove-protection="${escapeHtml(item.key)}">${escapeHtml(config.protectionRemove || config.remove || 'Remove')}</button></div><strong>${formatMoney(linePrice, currency)}</strong></article>`);
      });
      if (supportItems.length && !protectionItems.length && Number(config.protectionVariantId) > 0) {
        cards.push(`<article class="cart-protection-offer"><span class="cart-protection-offer__icon" aria-hidden="true">✓</span><div class="cart-protection-offer__copy"><b>${escapeHtml(config.protectionTitle || 'Add 90-day extra protection')}</b><small>${escapeHtml(config.protectionCopy || 'One replacement for accidental damage or DialFit failure.')}</small></div><div class="cart-protection-offer__action"><strong>${formatMoney(Number(config.protectionPrice || 0), currency)}</strong><button type="button" data-cart-add-protection>${escapeHtml(config.protectionAdd || 'Add protection')}</button></div></article>`);
      }
      itemsRoot.innerHTML = cards.join('');
      if (subtotal) subtotal.textContent = formatMoney(finalTotal, currency);
      if (savings) savings.textContent = `−${formatMoney(discountTotal, currency)}`;
      const checkoutPath = cartRoute('checkout');
      checkoutLink.href = supportQuantity > 0 && tier.code
        ? `/discount/${encodeURIComponent(tier.code)}?redirect=${encodeURIComponent(checkoutPath)}`
        : checkoutPath;
    };
    const getCart = async () => {
      const response = await fetch(cartRoute('cart.js'), { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    };
    const postCart = async (path, body) => {
      const response = await fetch(cartRoute(path), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      if (!response.ok) {
        const detail = await response.text();
        throw new Error(`Cart update failed (${response.status}): ${detail}`);
      }
      return response.json();
    };
    const applyBundle = async () => {
      const cart = await getCart();
      if (!cart.item_count) return cart;
      const supportQuantity = itemQuantity(supportItemsFrom(cart));
      const tier = supportQuantity > 0 ? tierFor(supportQuantity) : { code: '' };
      await postCart('cart/update.js', { discount: tier.code });
      return getCart();
    };
    const replaceBundle = async items => {
      const sessionId = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      const stagedItems = items.map(item => ({
        ...item,
        properties: {
          ...(item.properties || {}),
          _kynora_bundle_session: sessionId
        }
      }));

      const addedItems = await postCart('cart/add.js', { items: stagedItems });
      let latestCart = addedItems;
      try {
        const cart = await getCart();
        const updates = {};
        cart.items.forEach(item => {
          const properties = item.properties || {};
          const managedItem = properties._bundle || properties._protection;
          const belongsToCurrentBundle = properties._kynora_bundle_session === sessionId;
          if (managedItem && !belongsToCurrentBundle) updates[item.key] = 0;
        });
        latestCart = Object.keys(updates).length
          ? await postCart('cart/update.js', { updates })
          : cart;
        try {
          latestCart = await applyBundle();
        } catch (error) {
          console.error('Kynora bundle discount update failed:', error);
        }
      } catch (error) {
        console.error('Kynora previous bundle cleanup failed:', error);
      }
      return latestCart;
    };
    const refresh = async () => {
      itemsRoot.innerHTML = `<p class="cart-drawer__loading">${escapeHtml(config.loading || 'Loading your cart…')}</p>`;
      try {
        render(await getCart());
      } catch (_) {
        itemsRoot.innerHTML = `<p class="cart-drawer__empty">${escapeHtml(config.error || 'Your cart could not load. Please refresh and try again.')}</p>`;
      }
    };
    const open = async trigger => {
      lastTrigger = trigger || document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      panel?.focus();
      await refresh();
    };
    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
      lastTrigger?.focus?.();
    };
    const setBundleQuantity = async target => {
      if (quantityUpdatePending) return;
      quantityUpdatePending = true;
      itemsRoot.setAttribute('aria-busy', 'true');
      try {
        const cart = await getCart();
        const supportItems = supportItemsFrom(cart);
        if (!supportItems.length) return;
        const desired = Math.max(1, Number(target) || 1);
        const current = itemQuantity(supportItems);
        if (desired < current) {
          let remaining = desired;
          const updates = {};
          supportItems.forEach(item => {
            const kept = Math.min(item.quantity, remaining);
            updates[item.key] = kept;
            remaining -= kept;
          });
          await postCart('cart/update.js', { updates, discount: tierFor(desired).code });
        } else if (desired > current) {
          const first = supportItems[0];
          await postCart('cart/add.js', {
            items: [{
              id: first.variant_id,
              quantity: desired - current,
              properties: first.properties || {}
            }]
          });
          await postCart('cart/update.js', { discount: tierFor(desired).code });
        } else {
          await postCart('cart/update.js', { discount: tierFor(desired).code });
        }
        render(await getCart());
      } catch (_) {
        await refresh();
      } finally {
        quantityUpdatePending = false;
        itemsRoot.removeAttribute('aria-busy');
      }
    };
    const updateBundleUnit = async button => {
      if (quantityUpdatePending) return;
      const editor = button.closest('[data-cart-unit-editor]');
      if (!editor) return;
      const selectedOptions = [...editor.querySelectorAll('[data-cart-unit-option]')].map(select => select.value);
      const targetVariant = variantForOptions(selectedOptions);
      if (!targetVariant) {
        alert(cartErrorMessage());
        return;
      }

      quantityUpdatePending = true;
      itemsRoot.setAttribute('aria-busy', 'true');
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = config.updating || 'UPDATING…';
      try {
        const cart = await getCart();
        const sourceItem = cart.items.find(item => item.key === editor.dataset.lineKey);
        if (!sourceItem) throw new Error('Cart line unavailable');
        if (String(sourceItem.variant_id) !== String(targetVariant.id)) {
          await postCart('cart/add.js', {
            items: [{
              id: targetVariant.id,
              quantity: 1,
              properties: sourceItem.properties || {}
            }]
          });
          await postCart('cart/change.js', {
            id: sourceItem.key,
            quantity: Math.max(0, Number(sourceItem.quantity || 0) - 1)
          });
        }
        render(await applyBundle());
      } catch (error) {
        console.error('Kynora cart customization failed:', error);
        alert(cartErrorMessage());
        await refresh();
      } finally {
        quantityUpdatePending = false;
        itemsRoot.removeAttribute('aria-busy');
        if (button.isConnected) {
          button.textContent = originalText;
          button.disabled = false;
        }
      }
    };
    const removeBundle = async () => {
      itemsRoot.setAttribute('aria-busy', 'true');
      try {
        const cart = await getCart();
        const updates = {};
        cart.items.forEach(item => { updates[item.key] = 0; });
        render(await postCart('cart/update.js', { updates, discount: '' }));
      } catch (_) {
        await refresh();
      } finally {
        itemsRoot.removeAttribute('aria-busy');
      }
    };
    const addProtection = async () => {
      const variantId = Number(config.protectionVariantId || 0);
      if (!variantId) return;
      itemsRoot.setAttribute('aria-busy', 'true');
      try {
        await postCart('cart/add.js', {
          items: [{ id: variantId, quantity: 1, properties: { _protection: '90-day' } }]
        });
        render(await applyBundle());
      } catch (error) {
        console.error('Kynora protection add failed:', error);
        await refresh();
      } finally {
        itemsRoot.removeAttribute('aria-busy');
      }
    };
    const removeProtection = async key => {
      itemsRoot.setAttribute('aria-busy', 'true');
      try {
        await postCart('cart/change.js', { id: key, quantity: 0 });
        render(await applyBundle());
      } catch (_) {
        await refresh();
      } finally {
        itemsRoot.removeAttribute('aria-busy');
      }
    };
    document.addEventListener('click', event => {
      const opener = event.target.closest('[data-cart-open]');
      if (opener) {
        event.preventDefault();
        open(opener);
      }
    });
    drawer.querySelectorAll('[data-cart-close]').forEach(button => button.addEventListener('click', close));
    itemsRoot.addEventListener('change', event => {
      const select = event.target.closest('[data-cart-unit-option]');
      if (!select) return;
      const editor = select.closest('[data-cart-unit-editor]');
      editor?.classList.add('is-dirty');
      const applyButton = editor?.querySelector('[data-cart-unit-apply]');
      if (applyButton) applyButton.disabled = false;
    });
    itemsRoot.addEventListener('click', event => {
      const unitApply = event.target.closest('[data-cart-unit-apply]');
      if (unitApply) {
        updateBundleUnit(unitApply);
        return;
      }
      const quantity = event.target.closest('[data-bundle-quantity]');
      if (quantity) {
        setBundleQuantity(Number(quantity.dataset.bundleQuantity));
        return;
      }
      const protectionAdd = event.target.closest('[data-cart-add-protection]');
      if (protectionAdd) {
        addProtection();
        return;
      }
      const protectionRemove = event.target.closest('[data-cart-remove-protection]');
      if (protectionRemove) {
        removeProtection(protectionRemove.dataset.cartRemoveProtection);
        return;
      }
      if (event.target.closest('[data-cart-remove]')) removeBundle();
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
    window.KynoraCart = { open, close, refresh, applyBundle, replaceBundle };
  }
})();
